export * from './projekt-detail.component';
export * from './projekt-detail.component.module';